import forOwn from 'mout/object/forOwn'

/**
 * Computes byTest scoring object.
 * @param {string} thisSubtestId The id for the subtest being submitted.
 * @param {object} thisBySubtest The scoring object for the current subtest being submitted.
 * @param {object} prevSubtestScoring bySubtest object from userAssessment.
 * @returns {object} byTest scoring object.
 */
export default function computeByTestScore (thisSubtestId, thisBySubtest, prevSubtestScoring) {
  let raw = parseInt(thisBySubtest.raw, 10)
  let possible = parseInt(thisBySubtest.possible, 10)
  let scaleSum = parseInt(thisBySubtest.scale, 10)
  forOwn(prevSubtestScoring, (val, key, o) => {
    if (key !== thisSubtestId) {
      raw += parseInt(val.raw, 10)
      possible += parseInt(val.possible, 10)
      scaleSum += parseInt(val.scale, 10)
    }
  })
  const scale = Math.round(scaleSum / 4)
  return { 
    complete: true,
    percentage: raw / possible,
    possible,
    raw,
    scale,
  }
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/computeByTestScore.js